import React from "react";
import { StyledConfigurationBox, StyledContainer, StyledMarketplaceCalculatorOrg } from "./MarketplaceCalculatorOrg.styled";
import MarketplaceCalculatorResultBox from "./MarketplaceCalculatorResultBox";
function MarketplaceCalculatorOrg(_ref) {
  var configurationBox = _ref.configurationBox,
    resultBox = _ref.resultBox;
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyledMarketplaceCalculatorOrg, {
    spacingSpace: 2,
    borderRadiusSize: "xlarge"
  }, /*#__PURE__*/React.createElement(StyledConfigurationBox, {
    flexBasis: "0%",
    flexShrink: 1,
    flexGrow: 1
  }, configurationBox), /*#__PURE__*/React.createElement(MarketplaceCalculatorResultBox, resultBox)));
}
export default MarketplaceCalculatorOrg;